/* FAN preference uses an audited design identifier, never the display title. */
(() => {
  'use strict';
  const norm = value => String(value || '').normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();

  function key(card) {
    let tags = [];
    try { tags = JSON.parse(card.dataset.fdCardTags || '[]'); } catch (_) {}
    return tags.find(tag => /^FD_VERIFIED_PAIR:[A-Za-z0-9_-]+$/.test(tag)) || '';
  }

  function player(card) {
    if (card.dataset.fdCardFan === 'true') return false;
    const title = norm(card.dataset.fdTitle);
    const tags = norm(card.dataset.fdCardTags || card.dataset.fdTags);
    return /\bplayer\b|\bversion pro\b/.test(title) || /\bplayer version\b|\bversion player\b|\bversion pro\b/.test(tags);
  }

  function reconcile(parent) {
    const cards = [...parent.children].filter(node => node.matches?.('[data-fd-product-card]'));
    if (!cards.length) return;
    const fanKeys = new Set(cards.filter(card => !player(card)).map(key).filter(Boolean));
    for (const card of cards) {
      const pair = key(card);
      const hide = !!pair && player(card) && fanKeys.has(pair);
      if (hide && !card.dataset.fdFanPriorityHidden) {
        card.dataset.fdFanPriorityHidden = 'true';
        card.dataset.fdFanPriorityDisplay = card.style.display;
        card.style.display = 'none';
        card.setAttribute('aria-hidden', 'true');
      } else if (!hide && card.dataset.fdFanPriorityHidden) {
        card.style.display = card.dataset.fdFanPriorityDisplay || '';
        card.removeAttribute('aria-hidden');
        delete card.dataset.fdFanPriorityHidden;
        delete card.dataset.fdFanPriorityDisplay;
      }
    }
  }

  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      const parents = new Set();
      document.querySelectorAll('[data-fd-product-card]').forEach(card => {
        if (card.parentElement) parents.add(card.parentElement);
      });
      parents.forEach(reconcile);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === 1 && (node.matches?.('[data-fd-product-card]') || node.querySelector?.('[data-fd-product-card]'))))) schedule();
  }).observe(document.documentElement, {subtree:true, childList:true});
})();
